import { Injectable, signal } from '@angular/core';
import { CognitoAuthService } from '../auth/cognito-auth.service';

export interface BackofficeSession {
  userId: string;
  email: string;
  superAdmin: boolean;
}

@Injectable({ providedIn: 'root' })
export class BackofficeAuthService {
  private _session = signal<BackofficeSession | null>(null);

  readonly session = this._session.asReadonly();

  constructor(private readonly auth: CognitoAuthService) {}

  get isAuthenticated(): boolean {
    return this._session() !== null;
  }

  get isSuperAdmin(): boolean {
    return this._session()?.superAdmin === true;
  }

  async hydrateFromBff(): Promise<BackofficeSession | null> {
    const status = await this.auth.bootstrapSession();
    if (!status.authenticated) {
      this._session.set(null);
      return null;
    }

    const me = await this.auth.fetchMe();
    if (!me) {
      this._session.set(null);
      return null;
    }

    const session: BackofficeSession = {
      userId: me.global_user_id,
      email: me.email,
      superAdmin: me.isSuperAdmin,
    };
    this._session.set(session);
    return session;
  }

  async logout(): Promise<void> {
    await this.auth.logout();
    this._session.set(null);
  }
}
